import type { FullSubEvent } from '@fastnorth/timer-api';
import type { SubstitutionMap } from './types.ts';

type BuildSubEventSubstitutionsParams = {
  subEvent: FullSubEvent;
};

const buildSubEventSubstitutions = ({
  subEvent,
}: BuildSubEventSubstitutionsParams): SubstitutionMap => ({
  '%RACE_NAME%': subEvent.name || '',
  '%SUB_EVENT_NAME%': subEvent.name || '',
});

export default buildSubEventSubstitutions;
